export default __webpack_public_path__ + "b0fa7903b809cece09b6e5d6b5a6e89e.png";